import { Col, Row, Select } from 'antd'
import {
  AdminJobBoardsVacanciesGetListApplicantsResponseItems,
  AdminJobBoardsVacanciesGetListApplicantsResponseSummary,
  JobBoardsVacanciesApplicationStatusEnum,
  OrderDirectionEnum,
} from 'generated/api'
import JobVacancyApplicantTable from './JobVacancyApplicantTable'
import { sortFieldJobApplicantsEnum } from '../hooks/jobVacancyEnum'
import Card from 'components/card/Card'
import Pagination from 'components/pagination/Pagination'
import Errors from 'components/errors/Errors'
import { DropDownStatusJobApplicant } from 'constants/dropdown'

interface IJobVacancyApplicantsCard {
  summary: AdminJobBoardsVacanciesGetListApplicantsResponseSummary
  fetchStatusJobApplicants: 'loading' | 'idle' | 'error'
  selectedStatusJobApplicants: JobBoardsVacanciesApplicationStatusEnum
  applicants: AdminJobBoardsVacanciesGetListApplicantsResponseItems[]
  pageApplicants: number
  limitApplicants: number
  totalPageApplicants: number
  columnsSortBy: OrderDirectionEnum
  columnsSortField: sortFieldJobApplicantsEnum
  fetchJobApplicants: () => void
  onChangeSelectedStatusJobApplicants: (status: JobBoardsVacanciesApplicationStatusEnum) => void
  onChangeLimitApplicants: (limit: number) => void
  onChangePageApplicants: (page: number) => void
  onSort: (field: sortFieldJobApplicantsEnum) => void
  onOpenModalUpdateApplicantStatus: (
    id: string,
    nextStatus: JobBoardsVacanciesApplicationStatusEnum,
  ) => void
}

export default function JobVacancyApplicantsCard(props: IJobVacancyApplicantsCard) {
  const {
    summary,
    fetchStatusJobApplicants,
    selectedStatusJobApplicants,
    applicants,
    pageApplicants,
    limitApplicants,
    totalPageApplicants,
    columnsSortBy,
    columnsSortField,
    fetchJobApplicants,
    onChangeSelectedStatusJobApplicants,
    onChangeLimitApplicants,
    onChangePageApplicants,
    onSort,
    onOpenModalUpdateApplicantStatus,
  } = props

  const loading = fetchStatusJobApplicants === 'loading'
  const failed = fetchStatusJobApplicants === 'error'

  return (
    <Card className="rounded-lg p-0" loading={loading}>
      <Card.Header className="px-4 py-2">
        <Row gutter={[8, 8]} className="w-full">
          <Col span={24} lg={20}>
            {!failed && (
              <>
                <span className="text-[#212121] text-base">
                  <span className="font-bold">{summary.totalApplicant}</span>{' '}
                  <span className="font-medium">Pelamar Kerja</span>
                </span>
                <div className="flex gap-2">
                  <span className="text-[#FCA501] text-xs">
                    <span className="font-bold">{summary.statusPending}</span>{' '}
                    <span className="font-medium">Menunggu</span>
                  </span>
                  <span className="text-[#72BA24] text-xs">
                    <span className="font-bold">{summary.statusAccepted}</span>{' '}
                    <span className="font-medium">Diterima</span>
                  </span>
                  <span className="text-[#FF4D4D] text-xs">
                    <span className="font-bold">{summary.statusRejected}</span>{' '}
                    <span className="font-medium">Ditolak</span>
                  </span>
                </div>
              </>
            )}
          </Col>
          <Col span={24} lg={{ span: 4 }}>
            <Select
              data-testid="select_category_job_vacancy"
              value={selectedStatusJobApplicants}
              className="dropdown-search"
              onChange={(status: JobBoardsVacanciesApplicationStatusEnum) =>
                onChangeSelectedStatusJobApplicants(status)
              }
            >
              {DropDownStatusJobApplicant.map(status => {
                return (
                  <Select.Option
                    data-testid={`select_statusJobApplicant_${status.value}`}
                    key={status.value}
                    value={status.value}
                  >
                    {status.label}
                  </Select.Option>
                )
              })}
            </Select>
          </Col>
        </Row>
      </Card.Header>
      {!failed && (
        <>
          <Card.Body className="mt-0">
            <JobVacancyApplicantTable
              loading={loading}
              data={applicants}
              columnsSortBy={columnsSortBy}
              columnsSortField={columnsSortField}
              onSort={onSort}
              onOpenModalUpdateApplicantStatus={onOpenModalUpdateApplicantStatus}
            />
          </Card.Body>
          <Card.Footer>
            <div className="px-4 pb-4">
              <Pagination
                showLimitPage={true}
                limit={limitApplicants}
                currentPage={pageApplicants}
                totalRows={totalPageApplicants}
                setLimit={limit => onChangeLimitApplicants(limit)}
                onPageChanged={page => onChangePageApplicants(page)}
              />
            </div>
          </Card.Footer>
        </>
      )}
      {failed && (
        <div className="pb-2">
          <Errors
            data-testid="error_fetch_job_applicant"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={fetchJobApplicants}
          />
        </div>
      )}
    </Card>
  )
}
